import { ACTION_ITEMS } from '../../../../constants/organizations.constants';

const styles = {
  all: 'All',
  needsForms: ACTION_ITEMS.needsForms,
  needsActionPlan: ACTION_ITEMS.needsActionPlan,
  needsCapture: ACTION_ITEMS.needsCapture
};

export default styles;